import React, { useState, useEffect } from 'react';
import Icon from './AppIcon';

const BibleVerse = () => {
  const [verse, setVerse] = useState(null);
  const [loading, setLoading] = useState(true);

  // Array de versículos bíblicos predefinidos como respaldo
  const fallbackVerses = [
    {
      text: "Toda la Escritura es inspirada por Dios, y útil para enseñar, para redargüir, para corregir, para instruir en justicia.",
      reference: "2 Timoteo 3:16"
    },
    {
      text: "Lámpara es a mis pies tu palabra, y lumbrera a mi camino.",
      reference: "Salmos 119:105"
    },
    {
      text: "Porque la palabra de Dios es viva y eficaz, y más cortante que toda espada de dos filos.",
      reference: "Hebreos 4:12"
    },
    {
      text: "Escudriñad las Escrituras; porque a vosotros os parece que en ellas tenéis la vida eterna; y ellas son las que dan testimonio de mí.",
      reference: "Juan 5:39"
    },
    {
      text: "La hierba se seca, y la flor se marchita; mas la palabra del Dios nuestro permanece para siempre.",
      reference: "Isaías 40:8"
    },
    {
      text: "No sólo de pan vivirá el hombre, sino de toda palabra que sale de la boca de Dios.",
      reference: "Mateo 4:4"
    },
    {
      text: "Bienaventurados los que oyen la palabra de Dios, y la guardan.",
      reference: "Lucas 11:28"
    },
    {
      text: "Santifícalos en tu verdad; tu palabra es verdad.",
      reference: "Juan 17:17"
    }
  ];

  useEffect(() => {
    const fetchVerse = async () => {
      try {
        // Intentar obtener versículo de API
        const response = await fetch('https://bible-api.com/random?translation=rvr1960');
        
        if (response.ok) {
          const data = await response.json();
          setVerse({
            text: data.text.trim(),
            reference: data.reference
          });
        } else {
          throw new Error('API no disponible');
        }
      } catch (error) {
        console.log('Usando versículo predefinido:', error.message);
        // Usar versículo aleatorio del array de respaldo
        const randomIndex = Math.floor(Math.random() * fallbackVerses.length);
        setVerse(fallbackVerses[randomIndex]);
      } finally {
        setLoading(false);
      }
    };

    fetchVerse();
  }, []);

  if (loading) {
    return (
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4 mt-4">
        <div className="flex items-center space-x-2">
          <Icon name="Loader" size={16} className="animate-spin text-blue-600" />
          <span className="text-sm text-blue-700">Cargando versículo...</span>
        </div>
      </div>
    );
  }

  if (!verse) return null;

  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4 mt-4">
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0 mt-1">
          <Icon name="BookOpen" size={20} className="text-blue-600" />
        </div>
        <div className="flex-1">
          <blockquote className="text-sm text-blue-800 italic leading-relaxed mb-2">
            "{verse.text}"
          </blockquote>
          <cite className="text-xs font-semibold text-blue-700 not-italic">
            — {verse.reference}
          </cite>
        </div>
      </div>
    </div>
  );
};

export default BibleVerse;

